import { RiskAiRiskType } from '@Quarantine/RiskAI/types';
import { useQuarantineStore } from '.';

export default function useRiskTypeBasedSelector() {
  return useQuarantineStore((state) => {
    const riskType = state.riskAi.filters.riskTypeFilter.currentValue;
    const isAnomaly = [
      RiskAiRiskType.Anomaly,
      RiskAiRiskType.CustomizedAnomaly,
    ].includes(riskType);
    return {
      riskNameFilter: isAnomaly
        ? state.riskAi.filters.anomalyNameFilter
        : state.riskAi.filters.securityRiskNameFilter,
      riskNameFilterName: (isAnomaly
        ? 'anomalyNameFilter'
        : 'securityRiskNameFilter') as
        | 'anomalyNameFilter'
        | 'securityRiskNameFilter',
      columnConfig: {
        [RiskAiRiskType.Anomaly]: state.riskAi.anomalyColumnConfig,
        [RiskAiRiskType.CustomizedAnomaly]:
          state.riskAi.customizedAnomalyColumnConfig,
        [RiskAiRiskType.SecurityRisk]: state.riskAi.securityRiskColumnConfig,
      }[riskType],
      setColumnConfig: {
        [RiskAiRiskType.Anomaly]: state.riskAi.setAnomalyColumnConfig,
        [RiskAiRiskType.CustomizedAnomaly]:
          state.riskAi.setCustomizedAnomalyColumnConfig,
        [RiskAiRiskType.SecurityRisk]: state.riskAi.setSecurityRiskColumnConfig,
      }[riskType],
    };
  });
}
